import immutable from 'immutability-helper';
import { REHYDRATE } from 'redux-persist/lib/constants';
import { createReducer } from 'modules/helpers';
import { ActionTypes } from 'constants/index';

let isfirstvisit = true;
if (localStorage.isfirstvisit === '1') {
  isfirstvisit = false;
}

export const appState = {
  alerts: [],
  draweropened: false,
  isfirstvisit: true,
  edges: { data: [] },
  nodes: { data: [] },
  allnodes: { data: [] },
  tags: { data: [] },
  html: { data: [] },
  nodeid: 0,
  edgeid: 0,
  info: { data: [] },
};

export default {
  app: createReducer(appState, {
    [REHYDRATE](state) {
      return immutable(state, {
        alerts: { $set: [] },
      });
    },
    [ActionTypes.HIDE_ALERT](state, { payload: { id } }) {
      const alerts = state.alerts.filter(d => d.id !== id);

      return immutable(state, {
        alerts: { $set: alerts },
      });
    },
    [ActionTypes.SHOW_ALERT](state, { payload }) {
      return immutable(state, {
        alerts: { $push: [payload] },
      });
    },
    [ActionTypes.DRAWER_CHANGE](state, { payload }) {
      return immutable(state, {
        draweropened: { $set: payload.draweropened },
      });
    },
    [ActionTypes.CLOSE_INTRO](state, { payload }) {
      localStorage.isfirstvisit = 1;
      return immutable(state, {
        isfirstvisit: { $set: false },
      });
    },
    [ActionTypes.SHOW_INTRO](state, { payload }) {
      return immutable(state, {
        isfirstvisit: { $set: true },
      });
    },
    [ActionTypes.GET_HTML](state, { payload }) {
      return immutable(state, {
        error: { $set: false },
        isRunning: { $set: true },
      });
    },
    [ActionTypes.GET_HTML_SUCCESS](state, { payload }) {
      return immutable(state, {
        html: {
          data: { $set: payload.data || '' },
          isRunning: { $set: false },
        },
      });
    },
    [ActionTypes.GET_HTML_FAILURE](state, { payload }) {
      return immutable(state, {
        error: { $set: false },
        isRunning: { $set: false },
      });
    },
    [ActionTypes.GET_NODES](state, { payload }) {
      return immutable(state, {
        error: { $set: false },
        isRunning: { $set: true },
        tag: { $set: payload.tag },
      });
    },
    [ActionTypes.GET_EDGES](state, { payload }) {
      return immutable(state, {
        error: { $set: false },
        isRunning: { $set: true },
      });
    },
    [ActionTypes.GET_EDGES_SUCCESS](state, { payload }) {
      return immutable(state, {
        edges: {
          data: { $set: payload.data || [] },
          isRunning: { $set: false },
        },
      });
    },
    [ActionTypes.GET_EDGES_FAILURE](state, { payload }) {
      return immutable(state, {
        error: { $set: false },
        isRunning: { $set: false },
      });
    },
    [ActionTypes.GET_NODES_SUCCESS](state, { payload }) {
      return immutable(state, {
        nodes: {
          data: { $set: payload.data || [] },
        },
        isRunning: { $set: false },
      });
    },
    [ActionTypes.GET_ALL_NODES_SUCCESS](state, { payload }) {
      return immutable(state, {
        allnodes: {
          data: { $set: payload.data || [] },
        },
        isRunning: { $set: false },
      });
    },
    [ActionTypes.GET_TAGS_SUCCESS](state, { payload }) {
      return immutable(state, {
        tags: {
          data: { $set: payload.data || [] },
        },
        isRunning: { $set: false },
      });
    },
    [ActionTypes.SET_TAG_SUCCESS](state, { payload }) {
      return immutable(state, {
        tag: {
          data: { $set: payload.data || [] },
        },
        isRunning: { $set: false },
      });
    },
    [ActionTypes.GET_NODES_FAILURE](state, { payload }) {
      return immutable(state, {
        error: { $set: false },
        isRunning: { $set: false },
      });
    },
    [ActionTypes.SET_DETAIL](state, { payload }) {
      return immutable(state, {
        info: { $set: payload.info || [] },
        isRunning: { $set: false },
      });
    },
    [ActionTypes.SET_DETAIL_SUCCESS](state, { payload }) {
      return immutable(state, {
        info: { $set: payload.info || [] },
        isRunning: { $set: false },
      });
    },
    [ActionTypes.SET_DETAIL_FAILURE](state, { payload }) {
      return immutable(state, {
        error: { $set: false },
        isRunning: { $set: false },
      });
    },
    [ActionTypes.INFO_DRAWER_CHANGE](state, { payload }) {
      return immutable(state, {
        infodraweropened: { $set: payload.draweropened },
      });
    },
    [ActionTypes.GET_NODES_BY_FLAG](state, { payload }) {
      return immutable(state, {
        error: { $set: false },
        isRunning: { $set: true },
        flag: { $set: payload.country },
      });
    },
    [ActionTypes.SET_NODES](state, { payload }) {
      return immutable(state, {
        nodes: {
          data: { $set: payload.nodes.filtered_nodes || [] },
        },
        isRunning: { $set: false },
      });
    },
  }),
};



// WEBPACK FOOTER //
// ./scripts/reducers/app.js